import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  shipperList: [],
  errorShipperList: false,
  isLoadingShipperList: false,

  consigneeList: [],
  errorConsigneeList: false,
  isLoadingConsigneeList: false,

  isCreated: false,
  errorCreated: false,
  isCreating: false,

  editAddress: {},
  isLoadingEditAddress: false,
  errorEditAddress: false,

  dataAddressTemp: {},
  isLoadingDataAddress: false,

  messageDelete: {},
  isLoadingDelete: false,
  errorDelete: false,

  addressVerivied: [],
  errorAddressVerivied: false,
  isLoadingAddressVerivied: false,

  addressVeriviedFilter: [],
  errorAddressVeriviedFilter: false,
  isLoadingAddressVeriviedFilter: false,

  address: [],
  errorAddress: false,
  isLoadingAddress: false,

  addressFilter: [],
  errorAddressFilter: false,
  isLoadingAddressFilter: false,

  addMoreAddress: {},
  errorAddMoreAddress: false,
  isLoadingAddMoreAddress: false,

  removeAddress: {},
  errorRemoveAddress: false,
  isLoadingRemoveAddress: false,

  setBillingAddress: {},
  errorSetBillingAddress: false,
  isLoadingSetBillingAddress: false,

  editMyAddress: {},
  errorEditMyAddress: false,
  isLoadingEditMyAddress: false,
  
  billingAddress: {},
  isLoadingBillingAddress: false,
  errorBillingAddress: false,

  billingAddressGlobal: null,
  isLoadingDataBillingGlobal: false
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/address/index.js